import React, { FC, memo } from 'react'
import PrevButton from 'components/PrevButton'
import { TelInputProps } from '../types'
import { useTelInput } from '../useTelInput'
import styles from './style.module.css'

const PcTelInput: FC<TelInputProps> = ({
  title,
  isOpen,
  isShowPhoneNumberPrefix = false,
  maxLengthLeft = 3,
  maxLengthCenter = 4,
  maxLengthRight = 4,
  onClickEnter,
  onClickClose,
}) => {
  const {
    left,
    center,
    right,
    value,
    canClickEnter,
    onClickNumber,
    onClickBackSpace,
    onChangeLeft,
    onChangeCenter,
    onChangeRight,
  } = useTelInput({ maxLengthLeft, maxLengthCenter, maxLengthRight })

  if (!isOpen) return null

  return (
    <div className={styles.overlay}>
      <div className={styles.modal}>
        <div className={styles.header}>
          <div className={styles.headerBox}>
            <PrevButton onClick={() => onClickClose(value)} />
          </div>
          <div className={styles.headerCenterBox}>
            <span>{title}</span>
          </div>
          <div className={styles.headerBox} />
        </div>

        <div className={styles.inputArea}>
          <input className={styles.input} type="text" value={left} maxLength={maxLengthLeft} onChange={onChangeLeft} />
          <span className={styles.separator}>-</span>
          <input className={styles.input} type="text" value={center} maxLength={maxLengthCenter} onChange={onChangeCenter} />
          <span className={styles.separator}>-</span>
          <input className={styles.input} type="text" value={right} maxLength={maxLengthRight} onChange={onChangeRight} />
        </div>

        <div className={isShowPhoneNumberPrefix ? styles.keypadWrapper : styles.keypadWrapperNoPrefix}>
          {/* left: phone number prefix */}
          {isShowPhoneNumberPrefix && (
            <div className={styles.prefixColumn}>
              <button
                className={`${styles.numberButton} ${value.length ? styles.prefixButtonDisabled : ''}`}
                onClick={() => onClickNumber('070')}
                disabled={!!value.length}
              >
                070
              </button>
              <button
                className={`${styles.numberButton} ${value.length ? styles.prefixButtonDisabled : ''}`}
                onClick={() => onClickNumber('080')}
                disabled={!!value.length}
              >
                080
              </button>
              <button
                className={`${styles.numberButton} ${value.length ? styles.prefixButtonDisabled : ''}`}
                onClick={() => onClickNumber('090')}
                disabled={!!value.length}
              >
                090
              </button>
            </div>
          )}

          {/* center: number buttons */}
          <div className={styles.numberCenter}>
            <div>
              <button className={`${styles.numberButton} ${styles.numberRowButton}`} onClick={() => onClickNumber('1')}>1</button>
              <button className={`${styles.numberButton} ${styles.numberRowButton}`} onClick={() => onClickNumber('2')}>2</button>
              <button className={styles.numberButton} onClick={() => onClickNumber('3')}>3</button>
            </div>
            <div>
              <button className={`${styles.numberButton} ${styles.numberRowButton}`} onClick={() => onClickNumber('4')}>4</button>
              <button className={`${styles.numberButton} ${styles.numberRowButton}`} onClick={() => onClickNumber('5')}>5</button>
              <button className={styles.numberButton} onClick={() => onClickNumber('6')}>6</button>
            </div>
            <div>
              <button className={`${styles.numberButton} ${styles.numberRowButton}`} onClick={() => onClickNumber('7')}>7</button>
              <button className={`${styles.numberButton} ${styles.numberRowButton}`} onClick={() => onClickNumber('8')}>8</button>
              <button className={styles.numberButton} onClick={() => onClickNumber('9')}>9</button>
            </div>
            <div>
              <button className={`${styles.numberButton} ${styles.zeroButton}`} onClick={() => onClickNumber('0')}>0</button>
            </div>
          </div>

          {/* right: backspace + enter */}
          <div className={styles.rightColumn}>
            <button className={`${styles.numberButton} ${styles.backspaceButton}`} onClick={onClickBackSpace}>
              一文字消す
            </button>
            <button
              className={`${styles.numberButton} ${canClickEnter ? styles.enterButton : styles.enterButtonDisabled}`}
              disabled={!canClickEnter}
              onClick={() => onClickEnter(value)}
            >
              決定
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}

export default memo(PcTelInput)
